export function selectRelatedCards(responseHtml, currentProductUrl, requestedUrl, finalUrl) {
  const requestedPath = new URL(requestedUrl, 'http://localhost').pathname;
  const finalPath = new URL(finalUrl, new URL(requestedUrl, 'http://localhost')).pathname;
  if (finalPath !== requestedPath) return '';

  const currentPath = new URL(currentProductUrl, 'http://localhost').pathname;
  const cards = [];
  const cardPattern = /<a\b[^>]*class=["'][^"']*\bvlx-related-reference-results__card\b[^"']*["'][^>]*>[\s\S]*?<\/a>/gi;
  for (const match of String(responseHtml).matchAll(cardPattern)) {
    const href = match[0].match(/\bhref=["']([^"']+)["']/i)?.[1];
    if (href && new URL(href, 'http://localhost').pathname !== currentPath) cards.push(match[0]);
  }
  return cards.join('');
}

if (typeof window !== 'undefined') {
  window.selectRelatedCards = selectRelatedCards;
  const anchor = document.querySelector('[data-related-reference-request]');
  const target = document.querySelector('[data-related-reference-target]');
  if (anchor && target) {
    const requestedUrl = anchor.getAttribute('href');
    fetch(requestedUrl).then(async response => {
      if (!response.ok || response.redirected) return;
      const html = selectRelatedCards(
        await response.text(),
        target.dataset.currentUrl,
        requestedUrl,
        response.url,
      );
      if (html) {
        target.innerHTML = html;
        target.removeAttribute('hidden');
      }
    }).catch(() => {});
  }
}
